// @ts-nocheck
import { Plugin } from '/root/workspace/ad-editor_hFqr/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
